import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FlexBoxFullWHRow } from '../../components/layout/layout.styles';
import MainBar from '../../components/layout/main-bar/main-bar.component';
import SideBar from '../../components/layout/side-bar/side-bar.component';
import { LOGIN_PAGE_ROUTE } from '../../constants/routes.constants';
import { selectAccessToken } from '../../store/auth/auth.selector';
import { getMyNodesStart } from '../../store/node/node.action';
import { selectMyNodes } from '../../store/node/node.selector';
import { clearProjectSelected } from '../../store/project/project.action';

const HomePage = () => {
    const accessToken = useSelector(selectAccessToken);
    const myNodes = useSelector(selectMyNodes);

    const navigate = useNavigate();

    const dispatch = useDispatch();

    useEffect(() => {
        if (!accessToken) {
            navigate(LOGIN_PAGE_ROUTE);
        }
    }, [accessToken, navigate]);

    useEffect(() => {
        if (accessToken) {
            dispatch(clearProjectSelected());
            dispatch(getMyNodesStart(null));
        }
    }, [dispatch, accessToken]);

    return (
        <FlexBoxFullWHRow gap={3}>
            <SideBar />
            <MainBar nodes={myNodes} />
        </FlexBoxFullWHRow>
    );
};

export default HomePage;
